import OrderTag from "./orderTag";
import Mail from "./mail";
import Contact from "./contact";
import Account from "./account";
import OrderPayStatus from "./orderPayStatus";
import Participant from "./participant";
import Remark from "./remark";
import GroupNumber from "./groupNumber";

export const OrderTagFragment = OrderTag;

export const MailFragment = Mail;

export const ContactFragment = Contact;

export const AccountFragment = Account;

export const OrderPayStatusFragment = OrderPayStatus;

export const ParticipantFragment = Participant;

export const RemarkFragment = Remark;

export const GroupNumberFragment = GroupNumber;
